import React from 'react';

const NavbarButton = ({ children, onClick }) => (
  <span className="navbar-button" onClick={onClick}>
    {children}
  </span>
);

export default NavbarButton;
